export enum GlassResizeMode {
	Right = "Right",
	Left = "Left",
	Both = "Both"
}